import { EditOutlined } from '@ant-design/icons';
import { getToggleActiveMenuItem } from '@/shared/utils/menuItems/getToggleActiveMenuItem';

export const getMenuItems = ({ record, actions }) => {
  const menuItems = [
    {
      key: 'edit',
      label: 'Editar',
      icon: <EditOutlined />,
      onClick: actions.edit.handler,
      loading: actions.edit.loading,
    },
    getToggleActiveMenuItem({
      record,
      onActivate: actions.activate.handler,
      onInactivate: actions.inactivate.handler,
      loading: actions.activate.loading || actions.inactivate.loading,
    }),
  ];

  return menuItems;
};
